module.exports = __webpack_public_path__ + "img/3_118.c536839d.png";